<template>
  <svg
    width="8"
    height="13"
    viewBox="0 0 8 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      id="Vector"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.646856 12.8551C0.600305 12.8086 0.563371 12.7535 0.538171 12.6927C0.512971 12.632 0.5 12.5669 0.5 12.5011C0.5 12.4354 0.512971 12.3702 0.538171 12.3095C0.563371 12.2488 0.600305 12.1936 0.646856 12.1472L6.29242 6.50182L0.646856 0.856484C0.60038 0.810002 0.563513 0.754819 0.53836 0.694087C0.513208 0.633354 0.500262 0.568261 0.500262 0.502526C0.500262 0.43679 0.513208 0.371697 0.53836 0.310965C0.563513 0.250232 0.60038 0.19505 0.646856 0.148567C0.693332 0.102085 0.748507 0.0652125 0.809231 0.0400565C0.869955 0.0149006 0.935039 0.00195312 1.00077 0.00195312C1.06649 0.00195313 1.13158 0.0149006 1.1923 0.0400565C1.25302 0.0652125 1.3082 0.102085 1.35468 0.148567L7.35314 6.14786C7.3997 6.1943 7.43663 6.24947 7.46183 6.31021C7.48703 6.37095 7.5 6.43606 7.5 6.50182C7.5 6.56758 7.48703 6.63269 7.46183 6.69343C7.43663 6.75417 7.3997 6.80934 7.35314 6.85578L1.35468 12.8551C1.30824 12.9016 1.25308 12.9386 1.19235 12.9638C1.13162 12.989 1.06652 13.002 1.00077 13.002C0.935015 13.002 0.869911 12.989 0.809181 12.9638C0.748451 12.9386 0.69329 12.9016 0.646856 12.8551Z"
      fill="#A3A3A3"
    />
  </svg>
</template>